import type { TFileReviewDetails } from "./types";

/** The subset of either review-caps hook this gate needs. */
type TDownloadCap = { canDownload: boolean };

/**
 * Whether the current user may download this file's artifacts — the original/
 * processed download picker in `createReviewTab` and the generated-export rows
 * in `createEtlTab` both gate on this.
 *
 * FinJournal files check the FinJournal cap; everything else (TB/GL/OTB/TBGL)
 * checks the TB/GL cap. One shared helper so a future change to the download
 * permissions matrix only has one call site to touch, not two independently
 * drifting copies of the same composite expression.
 */
export function canDownloadFileArtifact(
    file: Pick<TFileReviewDetails, "fileType">,
    finjournalCaps: TDownloadCap,
    tbglCaps: TDownloadCap,
): boolean {
    const isFinJournal = file.fileType === "financial_journals";
    const isTBGL = !isFinJournal;
    return !((isFinJournal && !finjournalCaps.canDownload) || (isTBGL && !tbglCaps.canDownload));
}
